import type { ConditionalFormattingRule } from "../store/schema/ConditionalFormattingRule";
import type { ConditionalFormattingScenario } from "../store/schema/ConditionalFormattingScenarioType";
import { getConditionalFormattingStore } from "../store/store";
import type { MailboxInfo } from "owa-client-types";
import { getEnterpriseOrPremiumLicenseStatus } from "owa-has-enterprise-or-premium-license-store";
import { isConditionSupportedForScenario } from "../utils/conditionalFormattingConditionTypeUtils";
import { owaComputedFn } from "owa-computed-fn";

export default function getApplicableConditionalFormattingRulesByMailbox(mailboxInfo: MailboxInfo, scenario: ConditionalFormattingScenario): ConditionalFormattingRule[] {
    if (getEnterpriseOrPremiumLicenseStatus() !== "HasEnterpriseOrPremiumLicense") {
        return [];
    }
    
    const rules = getConditionalFormattingStore(mailboxInfo, scenario).conditionalFormattingRules;
    return rules.filter(rule => !rule.conditions.some(condition => !isConditionSupportedForScenario(condition.type, scenario)));
}

export const getApplicableConditionalFormattingRulesByMailboxMemoized: typeof getApplicableConditionalFormattingRulesByMailbox = owaComputedFn(getApplicableConditionalFormattingRulesByMailbox);

export function hasApplicableConditionalFormattingRulesByMailboxInner(mailboxInfo: MailboxInfo, scenario: ConditionalFormattingScenario): boolean {
    const rules = getConditionalFormattingStore(mailboxInfo, scenario).conditionalFormattingRules;
    return rules.some(rule => rule.conditions.every(condition => isConditionSupportedForScenario(condition.type, scenario)));
}

export const hasApplicableConditionalFormattingRulesByMailbox: typeof hasApplicableConditionalFormattingRulesByMailboxInner = owaComputedFn(hasApplicableConditionalFormattingRulesByMailboxInner);
